import { createContext, useContext } from "react";

import type { RouterOutputs } from "~/utils/api";

export type Me = Exclude<RouterOutputs["context"]["person"], false>;

export const MeContext = createContext<Me | undefined>(undefined);

export const useMe = (): Me => {
  const person = useContext(MeContext);

  if (!person) {
    throw new Error("useMe must be used within OnlyAuthorized");
  }

  return person;
};

export const useMeOptional = (): Me | undefined => {
  return useContext(MeContext);
};
